module.exports = __webpack_public_path__ + "img/图片10.ad169e1e.png";